// Content extension (admin side): the product's own content.
// The tab is the old catalog editor's ContentTab, reused as it is — it reads and
// writes through the shared catalog editor (../shared/catalog-editor.jsx).
import { PencilSquareIcon } from "@heroicons/react/24/outline"
import ContentTab from "./ContentTab"
import { CatalogEditorProvider, catalogSection, catalogVisible, useCatalogVisibilityContext } from "../shared/catalog-editor"

export const StoreProductExtension = {
  id: "content",
  label: "Content",
  description: "The page-by-page content, the content settings, the PDF pipelines and the media library",
  section: {
    component: catalogSection(ContentTab),
    label: "Content",
    icon: PencilSquareIcon,
    order: 660,
    visible: catalogVisible("content"),
  },
  provider: CatalogEditorProvider,
  visibilityContext: useCatalogVisibilityContext,
}
